/**
 * Drives the subscription product cards rendered by sections/abonnement-products.liquid
 * and snippets/abonnement-product-card.liquid. Each card lets the shopper pick a
 * "cure" (a real product variant) and toggle between subscription and one-time
 * purchase (a real selling plan) before adding the matching variant/selling plan
 * to the cart via the theme's native <product-form> custom element.
 */
(function () {
  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    return amount.toFixed(2).replace('.', ',') + ' €';
  }

  function initCard(card, options) {
    var cures = Array.prototype.slice.call(card.querySelectorAll('[data-abo-cure]'));
    if (!cures.length) return;

    var header = card.querySelector('[data-abo-header]');
    var frequenceEl = card.querySelectorAll('[data-abo-frequence]');
    var titleEl = card.querySelector('[data-abo-title]');
    var checkEl = card.querySelector('[data-abo-check]');
    var oneshotLink = card.querySelector('[data-abo-oneshot-link]');
    var variantInput = card.querySelector('[data-abo-variant-input]');
    var sellingPlanInput = card.querySelector('[data-abo-selling-plan-input]');
    var ctaBtn = card.querySelector('[data-abo-cta]');
    var ctaPriceEl = card.querySelector('[data-abo-cta-price]');
    var ctaOldEl = card.querySelector('[data-abo-cta-old]');
    var klarnaAmountEl = card.querySelector('[data-abo-klarna-amount]');

    var selected = cures.filter(function (c) {
      return c.classList.contains('is-selected');
    })[0] || cures[0];
    var mode = 'abo';

    function cureAllowsSub(cureEl) {
      return !!(cureEl.dataset.sellingPlan && parseInt(cureEl.dataset.subPrice, 10) > 0);
    }

    function pct(cureEl) {
      var full = parseInt(cureEl.dataset.price, 10) || 0;
      var sub = parseInt(cureEl.dataset.subPrice, 10) || 0;
      if (!full || !sub) return 0;
      return Math.round(((full - sub) / full) * 100);
    }

    function applyTemplate(str, value) {
      return (str || '').replace(/#/g, value);
    }

    function render() {
      var allowsSub = cureAllowsSub(selected);
      if (!allowsSub) mode = 'oneshot';

      cures.forEach(function (cureEl) {
        cureEl.classList.toggle('is-selected', cureEl === selected);

        var full = parseInt(cureEl.dataset.price, 10) || 0;
        var compareAt = parseInt(cureEl.dataset.compareAt, 10) || 0;
        var sub = parseInt(cureEl.dataset.subPrice, 10) || 0;
        var days = parseInt(cureEl.dataset.days, 10) || 0;
        var label = cureEl.dataset.label || 'jour';
        var showSub = mode === 'abo' && cureAllowsSub(cureEl);
        var displayPrice = showSub ? sub : full;

        var freqEl = cureEl.querySelector('[data-abo-freq]');
        if (freqEl && !freqEl.hasAttribute('data-freq-override')) {
          freqEl.textContent = days > 0
            ? (mode === 'abo' ? 'Livraison automatique tous les ' + days + ' ' + label + (days > 1 ? 's' : '') : 'Achat unique')
            : '';
        }

        var nameEl = cureEl.querySelector('[data-abo-cure-name]');
        if (nameEl) {
          if (nameEl.dataset.defaultName === undefined) nameEl.dataset.defaultName = nameEl.textContent;
          var oneshotName = cureEl.dataset.oneshotName;
          nameEl.textContent = (mode !== 'abo' && oneshotName) ? oneshotName : nameEl.dataset.defaultName;
        }

        var priceEl = cureEl.querySelector('[data-abo-price]');
        if (priceEl) {
          var html = '';
          if (showSub) {
            html += '<span class="abo-was">' + formatMoney(full) + '</span>';
          } else if (compareAt > full) {
            html += '<span class="abo-was">' + formatMoney(compareAt) + '</span>';
          }
          html += '<div class="abo-now">' + formatMoney(displayPrice) + '</div>';
          if (days > 0) {
            html += '<span class="abo-perday">' + formatMoney(Math.round(displayPrice / days)) + '/' + label + '</span>';
          }
          priceEl.innerHTML = html;
        }
      });

      var allowsSubNow = cureAllowsSub(selected);
      if (header) header.classList.toggle('is-inactive', mode !== 'abo');
      if (checkEl) checkEl.textContent = mode === 'abo' ? '✓' : '';
      if (frequenceEl) frequenceEl.forEach(function (el) { el.style.display = mode === 'abo' ? '' : 'none'; });
      if (titleEl) {
        titleEl.textContent = mode === 'abo'
          ? applyTemplate(options.aboLabel, pct(selected))
          : options.aboLabelInactive;
      }
      if (oneshotLink) {
        oneshotLink.textContent = mode === 'abo'
          ? options.oneshotLinkText
          : applyTemplate(options.backToAboText, pct(selected));
        oneshotLink.style.display = allowsSubNow ? '' : 'none';
      }

      var full = parseInt(selected.dataset.price, 10) || 0;
      var sub = parseInt(selected.dataset.subPrice, 10) || 0;
      var showSub = mode === 'abo' && allowsSubNow;
      var price = showSub ? sub : full;

      if (ctaPriceEl) ctaPriceEl.textContent = '— ' + formatMoney(price);
      if (ctaOldEl) {
        if (showSub) {
          ctaOldEl.textContent = formatMoney(full);
          ctaOldEl.style.display = '';
        } else {
          ctaOldEl.style.display = 'none';
        }
      }
      if (klarnaAmountEl) {
        var n = options.klarnaInstallments || 3;
        klarnaAmountEl.textContent = formatMoney(Math.round(price / n));
      }

      if (variantInput) variantInput.value = selected.dataset.variantId;
      if (sellingPlanInput) {
        if (showSub) {
          sellingPlanInput.value = selected.dataset.sellingPlan;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }

      if (ctaBtn) {
        var available = selected.dataset.available === 'true';
        ctaBtn.disabled = !available;
        ctaBtn.toggleAttribute('aria-disabled', !available);
      }
    }

    cures.forEach(function (cureEl) {
      cureEl.addEventListener('click', function () {
        selected = cureEl;
        render();
      });
    });

    if (header) {
      header.addEventListener('click', function () {
        if (mode !== 'abo' && cureAllowsSub(selected)) {
          mode = 'abo';
          render();
        }
      });
    }

    if (oneshotLink) {
      oneshotLink.addEventListener('click', function () {
        mode = mode === 'abo' ? 'oneshot' : 'abo';
        render();
      });
    }

    render();
  }

  window.AboProductsInit = function (sectionId, options) {
    var root = document.getElementById('AboProducts-' + sectionId);
    if (!root) return;
    root.querySelectorAll('[data-abo-card]').forEach(function (card) {
      initCard(card, options || {});
    });
  };
})();
